import React, { useEffect, useState } from 'react';
import { Row, Col, Container, Button, Form, Card, Toast, InputGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../app/hooks';

import solarSharelogo from '../assets/images/rex-logo.png';
import { loginAsync, selectLoginError } from '../slices/auth.slice';

interface IFormField {
  [type: string]: any
}

const formField: IFormField = {};


interface Props {
  // setIsAuth: React.Dispatch<React.SetStateAction<boolean>>
}

const EMAIL_REGEX: RegExp = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

const Login: React.FC<Props> = () => {
  const navigate = useNavigate();
  //const authenticated: boolean = useAppSelector(isAuthenticated);
  const dispatch = useAppDispatch();
  const error: boolean = useAppSelector(selectLoginError);
  const [showPassword, setShowPassword] = useState(false);
  const [hideNotification, setHideNotification] = useState(false);
  const [validated, setValidated] = useState(false);
  const [formData, setForm] = useState(formField);
  const [isValidUsername, setValidUsername] = useState<boolean>(true);
  const [remember, setRemember] = useState<boolean>(false);

  useEffect(() => {
    const rememberMe = JSON.parse(localStorage.getItem('rememberMe')!);
    if (rememberMe) {
      setRemember(true);
      setForm({ ...formData, username: rememberMe.email, password: rememberMe.password });
    }
  }, []);

  const setField = (field: string, value: string) => {
    setForm({ ...formData, [field]: value });
  }

  const handleSubmit = async (event: any) => {
    setValidUsername(true);
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === true) {
      // setting username and password when remember me option is checked
      if (remember) {
        localStorage.setItem('rememberMe', JSON.stringify({
          email: formData.username,
          password: formData.password,
        }));
      } else {
        localStorage.removeItem('rememberMe');
      }
      await dispatch(loginAsync({ username: formData.username, password: formData.password }));
    }
    else {
      setValidated(true);
    }
    setHideNotification(false);
  };

  const handleForgotPassword = () => {
    // validate entered username
    setHideNotification(false);
    if (EMAIL_REGEX.test(formData.username)) {
      navigate('/forgot-password', {
        state: {
          username: formData.username,
        },
      });
    } else {
      setValidUsername(false);
    }
  }

  const onCloseNotification = () => {
    setHideNotification(true);
  }

  return (
    <div className='login-main'>
      <Container className='h-100'>
        <Row className='justify-content-center align-items-center h-100'>
          <Col lg="5" md sm>
            <Card className='login-card px-4 py-4'>
              <Card.Body>
                <div className='logo'>
                  <img alt='' src={solarSharelogo} />
                </div>
                <div className='title'><h2>Welcome</h2></div>
                <div className='caption'><p>Enter your login details to continue</p></div>
                <div className=' login-form'>
                  <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="email">
                      <Form.Label>Email</Form.Label>
                      <Row>
                        <Col>
                          <Form.Control
                            value={formData?.username}
                            required
                            type="email"
                            placeholder="Email"
                            onChange={(e: any) => setField('username', e.target.value)}
                          />
                        </Col>
                      </Row>
                      <Form.Control.Feedback type='invalid'>
                        Email is required
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="password">
                      <Form.Label>Password</Form.Label>
                      <Row>
                        <Col>
                          <InputGroup>
                            <Form.Control
                              value={formData?.password}
                              required
                              type={showPassword ? 'text' : 'password'}
                              placeholder="Password"
                              onChange={(e: any) => setField('password', e.target.value)}
                            />
                            <InputGroup.Text>
                              <span
                                className='passVisible'
                                onClick={() => setShowPassword(!showPassword)}>
                                <i className={showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'}>
                                </i>
                              </span>
                            </InputGroup.Text>
                          </InputGroup>
                        </Col>
                      </Row>
                      <Form.Control.Feedback type='invalid'>
                        Password is required
                      </Form.Control.Feedback>
                    </Form.Group>
                    {
                      ((error || !isValidUsername) && !hideNotification) ? <Toast
                        style={{
                          backgroundColor: '#d9534f',
                        }}
                        className='notification'
                        onClose={() => onCloseNotification()}
                        delay={4000} autohide>
                        <Toast.Body>
                          {(!isValidUsername) ? `Please enter valid email` : `Invalid username or password`}
                        </Toast.Body>
                      </Toast> : <></>
                    }
                    <Row>
                      <Col md="6">
                        <Form.Group className="mb-5" controlId="lockCheckbox">
                          <Form.Check type="checkbox"
                            label="Remember Me"
                            checked={remember}
                            onChange={(event) => setRemember(event.target.checked)}
                          />
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className="mb-5" controlId="forgotPassword">
                          <div className='forgotPassword-button' onClick={() => handleForgotPassword()}>
                            Forgot password?
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Button variant="primary" type="submit">
                      Login
                    </Button>
                  </Form>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Login;
